module.exports = __webpack_public_path__ + "static/media/platform_feature.d0caa30f.png";